"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FetchProfileFollowingEndpoint = void 0;
const fetch_profile_followers_1 = require("./fetch-profile-followers");
class FetchProfileFollowingEndpoint extends fetch_profile_followers_1.FetchProfileFollowersEndpoint {
    getUrl() {
        return `/v2/profiles/${this.profileId}/following/profiles`;
    }
}
exports.FetchProfileFollowingEndpoint = FetchProfileFollowingEndpoint;
